import categories from './categories'
import news from './news'
import blogs from './blogs'

export { news, categories, blogs }



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/reducers/index.js